import {Checkbox, CheckboxProps} from "@progress/kendo-react-inputs";
import {useEffect, useState} from "react";

export default function FlintCheckBox(props: FlintCheckboxProps) {
    const [labelClassNameLocal, setLabelClassNameLocal] = useState<string | undefined>(props.labelClassName);
    const {size = "large", rounded = "small", labelClassName, ...other} = props;
    useEffect(()=>{
        if (!labelClassName || labelClassName.indexOf('ms-') < 0)
            setLabelClassNameLocal(labelClassName=>labelClassName + ' ms-2');
    }, [labelClassName])
    return <Checkbox {...other} size={size} labelClassName={labelClassNameLocal} rounded={rounded}/>
}

export interface FlintCheckboxProps extends CheckboxProps {

}